import config from 'src/config'

class Stripe {
  constructor() {
    this._client = window.Stripe(config.STRIPE_KEY, {
      apiVersion: '2020-08-27',
    })
  }

  get client() {
    return this._client
  }

  getPaymentRequest(options) {
    return this._client.paymentRequest(options)
  }

  convertNumberToSubUnit(num) { //eslint-disable-line
    return num * 100
  }
}

export default new Stripe()



// WEBPACK FOOTER //
// ./src/lib/stripe.js